export const topMenuHeightLarge = 85
export const topMenuVerticalPaddingLarge = 10
export const topMenuHeightSmall = 50
export const leftDrawerWidthLarge = 250
